module.exports = __webpack_public_path__ + "static/stuart-a751f94a5f40044f6ca5cc6f946bb4ed.jpg";